var PROFILE_ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  MINI: 'mini',
  QA: 'qa',
  STAGE: 'stage',
  REAL: 'real'
};
var PROFILE = process.env.PROFILE;
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isProduction = process.env.NODE_ENV === 'production';
var isLocalProfile = PROFILE === PROFILE_ENV.LOCAL;
var isDevProfile = PROFILE === PROFILE_ENV.DEV;
var isMiniProfile = PROFILE === PROFILE_ENV.MINI;
var isQaProfile = PROFILE === PROFILE_ENV.QA;
var isStageProfile = PROFILE === PROFILE_ENV.STAGE;
var isRealProfile = PROFILE === PROFILE_ENV.REAL;

export { PROFILE, PROFILE_ENV, isBrowser, isDevProfile, isLocalProfile, isMiniProfile, isProduction, isQaProfile, isRealProfile, isStageProfile };
